import { useCurrentClientIfAvailable } from 'src/clients/context/CurrentClientProvider';
import { useAppContainerContext } from '../AppContainerContext';

type ChatEmptyMessage = {
  title: string;
  subtitle: string;
};

const CHAT_EMPTY_MESSAGES: Record<string, ChatEmptyMessage> = {
  'suitability-report-edit': {
    title: 'Chat mode activated',
    subtitle:
      "Ask anything about editing this document - structure, wording, improvements and more. I'm here to help.",
  },
};

const SINGLE_CLIENT_DEFAULT: ChatEmptyMessage = {
  title: 'Chat with Siesta',
  subtitle:
    'Ask me anything about your client - finances, meeting prep, document questions, and more.',
};

const CROSS_CLIENT_DEFAULT: ChatEmptyMessage = {
  title: 'Chat with Siesta',
  subtitle: 'Ask me anything about your clients - total asset breakdown and much more.',
};

export function useChatEmptyMessage(): ChatEmptyMessage {
  const { contentMeta } = useAppContainerContext();
  const { clientId } = useCurrentClientIfAvailable();
  const pageType = contentMeta?.pageType;

  if (pageType && CHAT_EMPTY_MESSAGES[pageType]) {
    return CHAT_EMPTY_MESSAGES[pageType];
  }
  return clientId ? SINGLE_CLIENT_DEFAULT : CROSS_CLIENT_DEFAULT;
}
